import AppConfig from "Config/AppConfig";
import React, { Component } from "react";
import styled from "styled-components";
import { Fonts, Metrics } from "Themes";
import styles from "./styles.module.css";

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding: 5px 10px;
  font-family: ${Fonts.primaryFontFamily}
  &:hover {
    text-decoration: underline;
  }
`;

const UserAvatar = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 10px;
  border: ${Metrics.borders.secondaryBorder};
`;

const UserAvatarStyle = {
  height: "50px",
  width: "50px",
  borderRadius: "10px",
  border: `${Metrics.borders.secondaryBorder}`,
};

class Avatar extends Component {
  state = {
    imageError: false,
  };
  render() {
    const {
      user: { avatar, firstName },
      onClick,
    } = this.props;
    const { imageError } = this.state;
    const profileAvatar = avatar;
    const DefaultPic = AppConfig.NoProfilePic;
    return (
      <div className={styles.avatar} onClick={onClick}>
        {imageError || !profileAvatar ? (
          <DefaultPic style={UserAvatarStyle} />
        ) : (
          <UserAvatar
            src={profileAvatar}
            alt={"Not found"}
            onError={() => this.setState({ imageError: true })}
          />
        )}
        <TextContainer>{firstName}</TextContainer>
      </div>
    );
  }
}

export default Avatar;
